import { PromocodeModel } from '../../models/promocode/promocode.model';
import { EventEmitter, Output } from '@angular/core';

export class PromocodeBase {

  promocode: PromocodeModel = new PromocodeModel();

  @Output() forceRefresh: EventEmitter<boolean> = new EventEmitter<boolean>();

}
